export default class PersonModel {
  constructor({
    name = '',
    company = '',
    phone = '',
    email = '',
    inn = '',
    kpp = '',
    deliveryType = null,
    courierNote = null,
  }) {
    this.name = name;
    this.company = company;
    this.isCompany = !!company;
    this.inn = inn;
    this.kpp = kpp;
    this.phone = phone;
    this.email = email;
    this.deliveryType = deliveryType;
    this.courierNote = courierNote;
  }
}
